import "./styles.css";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import { DEFAULT_CONFIGS } from "./configs/default_configs";

import conf from "../../../../application/config/config";

import { MdLockOutline } from "react-icons/md";
import { AiOutlineExclamationCircle } from "react-icons/ai";

function ResetPassword() {

  const [screenConfigs, setScreenConfigs] = useState(DEFAULT_CONFIGS);

  const inputRef = useRef(null);


  const { jwt_token } = useParams();

  const [requestSent, setRequestSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  let [form, updateForm] = useState({
    password: "",
    confirm_password: "",
  });


  const [passwordStrength, setPasswordStrength] = useState(0);

  const calculateStrength = (password) => {
    const length = password.length;
    let score = 0;

    if (length == 0) {
      return setPasswordStrength(0);
    }

    if (length >= 8) {
      score += 2;
    } else if (length >= 6) {
      score += 1;
    }

    if (/[a-z]/.test(password)) {
      score += 1;
    }

    if (/[A-Z]/.test(password)) {
      score += 1;
    }

    if (/[0-9]/.test(password)) {
      score += 1;
    }

    setPasswordStrength(score);
  };

  const passwordStrengthConfigs = {
    1: {
      label: "Muito Fraca",
      color: "red",
    },
    2: {
      label: "Fraca",
      color: "orange",
    },
    3: {
      label: "Boa",
      color: "#9ed654",
    },
    4: {
      label: "Forte",
      color: "#5ED445",
    },
    5: {
      label: "Muito Forte",
      color: "#58d6a2",
    },
  };


  const handleChange = (event) => {
    if (event.target.type === "checkbox") {
      return updateForm({ ...form, [event.target.name]: event.target.checked });
    }

    calculateStrength(event.target.value);

    updateForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (form.password != form.confirm_password) {
      updateForm({ ...form, confirm_password: "" });
      return setErrorMessage("As senhas não coincidem");
    }

    if (form.password.length < 8) {
      return setErrorMessage("A Senha deve conter no mínimo 8 caracteres");
    }

    axios
      .post(`${conf.endpoints.backend}core/users/recoverpasswordemail`, {
        password: form.password,
        jwt_token: jwt_token,
      })
      .then((resp) => {
        setRequestSent(true);
      })
      .catch((err) => {
        return setErrorMessage(err.response.data.msg);
      });
  };


  const loadScreenConfigs = async () => {
    axios.post(`${conf.endpoints.backend}core/loginconfigs/getloginconfigs`).then((resp) => {

      let server_configs = resp.data;

      if (server_configs.logo_img) {
        server_configs.logo_img = server_configs.logo_img;
      } else {
        server_configs.logo_img = DEFAULT_CONFIGS.logo_img;
      }

      if (server_configs.isotype_img) {
        server_configs.isotype_img = server_configs.isotype_img;
      } else {
        server_configs.isotype_img = DEFAULT_CONFIGS.isotype_img;
      }

      if (server_configs.background_img) {
        server_configs.background_img = server_configs.background_img;
      } else {
        server_configs.background_img = DEFAULT_CONFIGS.background_img;
      }

      setScreenConfigs(server_configs);
    });
  };


  useEffect(() => {
    loadScreenConfigs();

    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        inputRef.current.click();
      }
    };

    // Adiciona o listener de evento para capturar a tecla "Enter" pressionada
    document.addEventListener('keypress', handleKeyPress);

    // Remove o listener de evento quando o componente é desmontado
    return () => {
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, []);


  const overlayColor = () => {
    const banner_overlay_opacity = screenConfigs.banner_overlay_opacity;

    const transparencyValue = banner_overlay_opacity
      ? banner_overlay_opacity > 100
        ? 100
        : banner_overlay_opacity < 0
        ? 0
        : banner_overlay_opacity
      : 0;

    const alphaValue = Math.round((transparencyValue / 100) * 255);
    const hexOpacity = alphaValue.toString(16).toUpperCase().padStart(2, "0");
    const backgroundColor = `${screenConfigs.banner_primary_color}${hexOpacity}`;

    return backgroundColor;
  };


  if (requestSent) {
    return (
      <div className='resetpassword-main-container'>
        <div className='resetpassword-form-container'>
          <a href='#'>
            <img src={screenConfigs.isotype_img} style={{ height: "34px" }} />
          </a>
          <div className='login-form-header'>
            <h2 className='login-form-header-title'>Sua senha foi redefinida com sucesso.</h2>
            <p className='login-form-header-msg'>Retorne ao login e insira suas novas credenciais.</p>
          </div>
          <div className='resetpassword-form-footer'>
            <button
              onClick={() => {
                window.location.replace("/login");
              }}
              className='btn btn-outline-secondary back-button'
            >
              Voltar para Login
            </button>
          </div>
        </div>
        <div
          className='forgotpassword-background-image'
          style={{
            backgroundImage: `url(${screenConfigs.background_img})`,
          }}
        >
          <div
            className='forgotpassword-filter-overlay'
            style={{ backgroundColor: screenConfigs.banner_primary_color + "80" }}
          ></div>
        </div>
      </div>
    );
  }

  return (
    <div className='resetpassword-main-container'>
      <div className='resetpassword-form-container'>
        <a href='#'>
          <img src={screenConfigs.isotype_img} style={{ height: "34px" }} />
        </a>
        <div className='login-form-header'>
          <h2 className='login-form-header-title'>Redefina sua Senha</h2>
          <p className='login-form-header-msg'>Defina uma nova senha de acesso.</p>
        </div>
        <div className='resetpassword-form-body'>
          <div className='login-form-inputs-container'>
            <form>
              <div className='login-form-input'>
                <label htmlFor=''>Senha</label>
                <div
                  className='login-form-input-field'
                  style={errorMessage ? { borderColor: "#dc3545", backgroundColor: "#fff1f3" } : null}
                >
                  <MdLockOutline size={24} color={errorMessage ? "#dc3545" : "#808080"} />
                  <input
                    value={form.password}
                    name='password'
                    onChange={handleChange}
                    type='password'
                    placeholder='Insira sua senha'
                    style={errorMessage ? { boxShadow: "0 0 0 30px #fff1f3 inset" } : null}
                  />
                </div>
              </div>

              {passwordStrength > 0 ? (
                <div className='password-strength-bar'>
                  <div
                    className='strength-bar'
                    style={{
                      width: `${(passwordStrength / 5) * 100}%`,
                      backgroundColor: passwordStrengthConfigs[passwordStrength].color,
                    }}
                  ></div>
                  <div
                    className='password-strength-text'
                    style={{ color: passwordStrengthConfigs[passwordStrength].color }}
                  >
                    {passwordStrengthConfigs[passwordStrength].label}
                  </div>
                </div>
              ) : (
                <div style={{ height: 3 }}></div>
              )}
              {errorMessage && (
                <div className='login-form-error-message' style={{ marginTop: -7 }}>
                  <>
                    <AiOutlineExclamationCircle size={16} color={"#dc3545"} />
                    <span>{errorMessage}</span>
                  </>
                </div>
              )}
              <div className='login-form-input'>
                <label htmlFor=''>Confirmar Senha</label>
                <div
                  className='login-form-input-field'
                  style={errorMessage ? { borderColor: "#dc3545", backgroundColor: "#fff1f3" } : null}
                >
                  <MdLockOutline size={24} color={errorMessage ? "#dc3545" : "#808080"} />
                  <input
                    value={form.confirm_password}
                    id='confirm_password'
                    name='confirm_password'
                    onChange={handleChange}
                    type='password'
                    placeholder='Confirme sua senha'
                    style={errorMessage ? { boxShadow: "0 0 0 30px #fff1f3 inset" } : null}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className='resetpassword-form-footer'>
          <button
            onClick={handleSubmit}
            className='btn btn-primary btn-block'
            ref={inputRef}
            style={{ backgroundColor: screenConfigs.primary_color, border: "none" }}
          >
            Redefinir Senha
          </button>
        </div>
      </div>
      <div
        className='resetpassword-background-image'
        style={{
          backgroundImage: `url(${screenConfigs.background_img})`,
        }}
      >
        <div
          className='resetpassword-filter-overlay '
          style={{ backgroundColor: overlayColor() }}
        ></div>
      </div>
    </div>
  );
}

export default ResetPassword;
